import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import {Modal} from 'react-bootstrap';
import axios from '../../../interceptor/axios-config';
import { useGrade } from '../../../context/GradeContext';
import Swal from 'sweetalert2';
import { useSubjects } from '../../../context/SubjectContext';
import Alert from 'react-bootstrap/Alert';
import config from '../../../config';



const initialFormData = {
    subject_name:'', subject_for_class: '', subject_code:'',
  };

const prePrimarySection = ['Nursery', 'KG', 'KG-I', 'KG-II'];
const lowerPrimarySection = ['I', 'II', 'III', 'IV', 'V'];
const upperPrimarySection = ['VI', 'VII', 'VIII'];
const secondarySection = ['IX', 'X'];

const AddSubjectModal = forwardRef((props, ref) => {

    const { subList, refreshSubjectData } = useSubjects();
    const [modalBox, setModalBox] = useState(false);
    const { grade } = useGrade();
    const [formData, setFormData] = useState(initialFormData);
    const [errMsg, setErrMsg] = useState(null);

    const [fData, setFData] = useState([]);
    const [newSubject, setNewSubject] = useState(null);
    const [section, setSection] = useState('');
    const [count, setCount] = useState(0);
    const [code, setCode] = useState(null);


    useImperativeHandle(ref, () => ({
        openModal() {
            setModalBox(true);            
        },  
    }));
   
    const closeAddModal = () =>{
        setErrMsg(null);
        setNewSubject(null);
        setFormData(initialFormData);
        setModalBox(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;           
        setFormData({ ...formData, [name]: value });
        setNewSubject(e.target.value);
    };

    useEffect(()=>{
        if(subList.length > 0 && formData.subject_for_class !==''){
            const filteredGradeSubject = subList.filter(item => item.subject_for_class === formData.subject_for_class)
            setFData(filteredGradeSubject);
            setCount(filteredGradeSubject.length);
            setSection(formData.subject_for_class);
        }
    },[subList, formData.subject_for_class])

    

    useEffect(()=>{
        if(fData.length > 0 && newSubject !== null){
            const subjectExist = fData.some(subject => subject.subject_name === newSubject);
            if(subjectExist === true){
                setErrMsg('Subject already exists!');
            }else{
                setErrMsg(null); 
            }
        }
    },[fData, newSubject]);
    
    useEffect(()=>{
        let result = count + 1;
        if (prePrimarySection.includes(section)) {
            // setCode('PP'+section + '0' + result);
            if(section === 'Nursery'){
                setCode('PP10' + result);
            }else if(section ==='KG'){
                setCode('PP20' + result);
            }else if(section ==='KG-I'){
                setCode('PP20' + result);
            }else{
                setCode('PP30' + result);
            }
        }else if (lowerPrimarySection.includes(section)){
            if(section === 'I'){
                setCode('LP10' + result);
            }else if(section === 'II'){
                setCode('LP20' + result);
            }else if(section === 'III'){
                setCode('LP30' + result);
            }else if(section === 'IV'){
                setCode('LP40' + result);
            }else{
                setCode('LP50' + result);
            }
        }else if (upperPrimarySection.includes(section)){
            if(section ==='VI'){
                setCode('UP10' + result);
            }else if(section ==='VII'){
                setCode('UP20' + result);
            }else{
                setCode('UP30' + result);
            }
        }else if (secondarySection.includes(section)){
            if(section === 'IX'){
                setCode('SS10' + result);
            }else{
                setCode('SS20' + result);
            }
        }else{
            setCode(null);
        }
    },[section, count]);

    // console.log(section);
    useEffect(()=>{
        if(code !== null){
            setFormData({ ...formData,  subject_code:code})
        }
    },[code])

    // console.log(formData);
    const handleSubmit = async (event) => {

        try {
          event.stopPropagation();
          // First POST request
          const firstResponse = await axios.post(
            `${config.apiBaseUrl}/subject/addSubject.php`,
            formData
          );
      
          console.log('Subject added successfully:', firstResponse.data);
        //   alert(firstResponse.data.message);

          setFormData({
            subject_name: '',
            subject_code: '',
            subject_for_class: '',
          });
      
          // You can add further actions after the second successful request here
      
          Swal.fire({
            icon: 'success',
            title: 'Subject added',
            text: 'New subject added successfully!'
          });
          refreshSubjectData();
          setModalBox(false);
        } catch (error) {
          console.error('POST request error:', error);
          // Handle errors for both requests here
        }
      };


  return (
    <>
            <Modal  onHide={closeAddModal} show={modalBox} centered>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Add New Subject</h5>
                        <button type="button" className="btn-close"  onClick={closeAddModal}></button>
                    </div>
                    <div className="modal-body">
                        <div className="card-body">
                            <div className="row">
                                {/* <div className="col-xl-12 col-lg-4 d-block">
                                    <div className="mb-3">
                                        <h1>Add Subject</h1>
                                    </div>
                                </div> */}
                                {errMsg !== null
                                    ?(<Alert className='bg-danger'>
                                        {errMsg}
                                    </Alert>)
                                    :''
                                }
                                <div className="col-xl-12 col-sm-6">
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput4" className="form-label text-primary">Class<span className="required">*</span></label>
                                        {/* <input type="text" className="form-control" id="exampleFormControlInput4" placeholder="Wally" /> */}
                                        <select name="subject_for_class" value={formData.subject_for_class} onChange={handleChange} className="form-control" id="exampleFormControlInput4" required>
                                            <option value="">--Select Class--</option>
                                            {grade.map((item) => <option value={item.class_options}>{item.class_label}</option>)}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Subject Name<span className="required">*</span></label>
                                        <input                                                    
                                            type="text" 
                                            className="form-control" 
                                            id="exampleFormControlInput5" 
                                            name="subject_name"
                                            value={formData.subject_name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Code<span className="required">*</span></label>
                                        <input                                                    
                                            type="text" 
                                            className="form-control" 
                                            id="exampleFormControlInput5" 
                                            name="subject_code"
                                            value={formData.subject_code}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success light" onClick={handleSubmit} disabled={errMsg}>Save</button>
                        <button type="button" className="btn btn-danger light" onClick={closeAddModal}>Close</button>
                    </div>
                </div>                
            </Modal> 
        </>
  )
})

export default AddSubjectModal
